import { affiliationRoles } from '@/components/contacts/affiliations/AffiliationRoleCheckboxes'
import { AnyOfConditionRow } from '@/pages/SegmentBuiltInConditionRows'
import type { ConditionField, SegmentCondition } from '@/pages/SegmentRuleFields'

interface Props {
  conditions: SegmentCondition[]
  update: (field: ConditionField, next?: SegmentCondition) => void
}

export function AffiliationRoleCondition({ conditions, update }: Props) {
  const condition = conditions.find((row) => row.field === 'affiliation_role')
  return condition ? (
    <AnyOfConditionRow
      label="Affiliation role"
      condition={condition}
      options={affiliationRoles.map((role) => ({ value: role, label: role }))}
      onChange={(next) => update('affiliation_role', next)}
      onRemove={() => update('affiliation_role')}
    />
  ) : null
}

export function EngagementBandCondition({
  conditions,
  update,
}: {
  conditions: SegmentCondition[]
  update: (field: ConditionField, next?: SegmentCondition) => void
}) {
  const condition = conditions.find((row) => row.field === 'engagement_band')
  return condition ? (
    <AnyOfConditionRow
      label="Engagement Band"
      condition={condition}
      options={['Engaged', 'Drifting', 'Disengaged', 'New'].map((value) => ({
        value,
        label: value,
      }))}
      onChange={(next) => update('engagement_band', next)}
      onRemove={() => update('engagement_band')}
    />
  ) : null
}
